<template>
  <div class="bp-report-page">
    <el-button-group class="page-tabs">
      <el-button class="healthButton" @click="click(0)">数字档案</el-button>
      <el-button class="healthButton healthActive" @click="click(2)">高血压详细数据</el-button>
      <el-button class="healthButton" @click="click(3)">运动处方</el-button>
      <el-button class="healthButton" @click="click(1)">营养处方</el-button>
      <el-button class="healthButton" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(6)">药物方案</el-button>
      <el-button class="healthButton" @click="click(5)">运动随访</el-button>
    </el-button-group>

    <section class="patient-bar panel-blood">
      <div class="patient-avatar">
        <i class="el-icon-user-solid"></i>
      </div>
      <div>
        患者姓名：
        <strong>{{ info.name || "张某某" }}</strong>
      </div>
      <div>
        性别：
        <strong>{{ info.sex || "男" }}</strong>
      </div>
      <div>
        年龄：
        <strong>{{ info.age || "58岁" }}</strong>
      </div>
      <div>
        就诊号：
        <strong>{{ info.visitNo || info.archiveNo || "202405180123" }}</strong>
      </div>
      <div>
        监测日期：
        <strong>{{ monitorDate }}</strong>
      </div>
      <div>
        主诊医生：
        <strong>{{ info.doctorName || "--" }}</strong>
      </div>
    </section>

    <section class="panel-blood">
      <div class="section-title">
        <span>1</span>
        评估结果
      </div>
      <div class="result-grid">
        <div class="result-card">
          <div class="result-icon red">
            <i class="el-icon-s-claim"></i>
          </div>
          <div>
            <div class="result-label">血压分级</div>
            <div class="result-value danger">{{ bpReport.bpLevelText }}</div>
          </div>
        </div>
        <div class="result-card">
          <div class="result-icon orange">
            <i class="el-icon-first-aid-kit"></i>
          </div>
          <div>
            <div class="result-label">心血管风险分层</div>
            <div class="result-value danger">{{ this.bloodData.evaluateResult.cardiovascularRisk || "--" }}</div>
          </div>
        </div>
        <div class="result-card">
          <div class="result-icon teal">
            <i class="el-icon-data-line"></i>
          </div>
          <div>
            <div class="result-label">杓型血压节律</div>
            <div class="result-value teal-text">{{ bpReport.rhythmType || "非杓型" }}</div>
          </div>
        </div>
        <div class="result-card conclusion">
          <div class="result-icon purple">
            <i class="el-icon-document-checked"></i>
          </div>
          <div>
            <div class="result-label">本次评估结论</div>
            <div class="result-value danger">{{ bpReport.conclusion || "血压控制不佳，建议强化干预" }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="panel-blood detail-panel">
      <div class="section-title">
        <span>2</span>
        高血压详细数据
      </div>
      <div class="analysis-tabs">
        <button :class="daysIndex == 1 ? 'active' : ''" @click="chickDaysIndex(1)">每日分析</button>
        <button :class="daysIndex == 2 ? 'active' : ''" @click="chickDaysIndex(2)">每周分析</button>
        <button :class="daysIndex == 3 ? 'active' : ''" @click="chickDaysIndex(3)">每月分析</button>
      </div>
      <div class="detail-layout">
        <div class="metrics-wrap">
          <div class="metrics-grid">
            <div v-for="item in metrics" :key="item.title" class="metric-card" :class="['metric-' + item.type, item.tone]">
              <div class="metric-head" :class="{ centered: !item.icon }">
                <i v-if="item.icon" :class="item.icon"></i>
                <div>
                  <div class="metric-title">{{ item.title }}</div>
                  <div v-if="item.sub" class="metric-sub">{{ item.sub }}</div>
                </div>
              </div>
              <div v-if="item.type === 'pressure'" class="pressure-values">
                <div>
                  <span>收缩压</span>
                  <strong :class="item.color">{{ item.systolic }}</strong>
                  <em>mmHg</em>
                </div>
                <div>
                  <span>舒张压</span>
                  <strong :class="item.color">{{ item.diastolic }}</strong>
                  <em>mmHg</em>
                </div>
              </div>
              <div v-else-if="item.type === 'load'" class="load-content">
                <div class="ring" :class="item.tone" :style="{ '--rate': item.rate + '%' }">
                  <span>{{ item.rate }}%</span>
                </div>
              </div>
              <div v-else class="single-value">
                <strong :class="item.color">{{ item.value }}</strong>
                <em>{{ item.unit }}</em>
              </div>
              <div v-if="item.spark" class="sparkline" :class="item.tone">
                <span v-for="(height, index) in sparkHeights" :key="index" :style="{ '--h': height + 'px' }"></span>
              </div>
            </div>
          </div>
          <div class="load-note">负荷值说明：超过目标血压值的测量值占全部有效测量值的百分比</div>
        </div>

        <div class="trend-card">
          <div class="chart-title">24小时血压与心率趋势</div>
          <div ref="bpTrendChart" class="trend-chart"></div>
        </div>

        <aside class="trend-reading">
          <div class="side-title">趋势判读</div>
          <p>{{ this.bpReport.trendReading }}</p>
          <!-- <p>夜间下降幅度不足，不符合典型杓型血压节律。</p> -->
          <div class="reading-block">
            <span>夜间平均下降幅度</span>
            <strong>{{ this.bpReport.nightRecentRate }}%</strong>
          </div>
          <div class="reading-block">
            <span>正常参考值</span>
            <strong>&gt;10~20%</strong>
          </div>
        </aside>
      </div>
    </section>

    <section class="panel-blood compare-panel">
      <div class="compare-card">
        <div class="sub-title">白天与夜间血压负荷对比</div>
        <div class="load-rings">
          <div class="load-item">
            <!-- <div class="ring orange" style="--rate: 72%"> -->
              <div class="ring orange" :style="{ '--rate': bloodData.evaluateResult.bloodPressureLoadDaytime + '%' }">
              <span>{{ bloodData.evaluateResult.bloodPressureLoadDaytime }}</span>
            </div>
            <div>白天负荷（140/90）</div>
          </div>
          <div class="load-item">
            <!-- <div class="ring green" style="--rate: 58%"> -->
            <div class="ring green" :style="{ '--rate': bloodData.evaluateResult.bloodPressureLoadNight + '%' }">
              <span>{{ bloodData.evaluateResult.bloodPressureLoadNight }}</span>
            </div>
            <div>夜间负荷（120/80）</div>
          </div>
          <div class="legend">
            <span>
              <i class="passed"></i>
              超过目标值
            </span>
            <span>
              <i></i>
              未超过目标值
            </span>
          </div>
        </div>
      </div>
      <div class="compare-card">
        <div class="sub-title">血压异常测量分布（占比）</div>
        <div ref="bpPieChart" class="pie-chart"></div>
      </div>
      <div class="data-overview">
        <div class="sub-title">数据概览</div>
        <ul>
          <li>有效测量次数：{{ bloodData.bloodDetail.dataCount.count || "--" }} 次</li>
          <li>白天测量次数：{{ bloodData.bloodDetail.dataCount.dayCount || "--" }} 次</li>
          <li>夜间测量次数：{{ bloodData.bloodDetail.dataCount.nightCount || "--" }} 次</li>
          <li>数据有效率：100%</li>
        </ul>
      </div>
    </section>

    <section class="bottom-grid">
      <div class="panel-blood">
        <div class="section-title">
          <span>3</span>
          症状分析
          <small>（仅显示阳性结果）</small>
        </div>
        <div class="symptom-grid">
          <div class="symptom-card">
            <div class="symptom-title">
              <i class="el-icon-warning"></i>
              危险因素
            </div>
            <div class="two-col-list">
              <span v-for="item in riskFactors" :key="item">
                <i class="el-icon-success"></i>
                {{ item }}
              </span>
            </div>
          </div>
          <div class="symptom-card">
            <div class="symptom-title green-title">
              <i class="el-icon-connection"></i>
              靶器官损害
            </div>
            <ul class="check-list">
              <li v-for="item in organDamage" :key="item">
                <i class="el-icon-success"></i>
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="symptom-card">
            <div class="symptom-title purple-title">
              <i class="el-icon-s-opportunity"></i>
              临床并发症
            </div>
            <ul class="check-list">
              <li v-for="item in complications" :key="item">
                <i class="el-icon-success"></i>
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="panel-blood">
        <div class="section-title">
          <span>4</span>
          治疗指导
        </div>
        <div class="guidance-grid">
          <div>
            <div class="guide-title blue">
              <i class="el-icon-edit-outline"></i>
              药物治疗建议
            </div>
            <ul class="check-list">
              <li v-for="item in medicineAdvice" :key="item">
                <i class="el-icon-success"></i>
                {{ item }}
              </li>
            </ul>
          </div>
          <div>
            <div class="guide-title green">
              <i class="el-icon-s-promotion"></i>
              非药物干预建议
            </div>
            <ul class="check-list">
              <li v-for="item in lifestyleAdvice" :key="item">
                <i class="el-icon-success"></i>
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="follow-card">
            <div class="guide-title purple">
              <i class="el-icon-date"></i>
              随访建议
            </div>
            <p>2 周复查家庭血压记录</p>
            <p>4 周门诊复评</p>
            <div class="key-focus">
              <div>
                <i class="el-icon-star-on"></i>
                关键关注点
              </div>
              <span>晨峰明显</span>
              <span>夜间下降不足</span>
              <span>代谢危险因素多</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="summary-bar">
      <i class="el-icon-info"></i>
      综合判断：患者属于高危高血压人群，已存在靶器官损害及代谢相关危险因素，需尽快规范治疗并持续随访。
    </div>
  </div>
</template>

<script>
import { getArchiveInfo } from "@/api/health/manage";
import { getBloodDataSplice } from "@/api/health/dataSplice";

export default {
  name: "BodyComposition",
  data() {
    return {
      info: {},
      bpReport: {},
      proFessional: {},
      wxUserid: this.$route.query.wxUserId,
      trendChart: null,
      pieChart: null,
      sparkHeights: [12, 7, 10, 8, 13, 9, 15, 8, 16, 10, 7],
      riskFactors: ["体重：82 kg", "吸烟：是", "BMI：28.4", "家族史：阳性", "腰围：98 cm", "高脂血症：阳性"],
      organDamage: ["左心室肥厚", "颈动脉硬化斑块", "肾功能轻度受损", "微量白蛋白尿"],
      complications: ["糖尿病", "外周动脉疾病"],
      medicineAdvice: ["建议启动或优化联合降压治疗。", "可考虑 ACEI/ARB 联合 CCB 方案。", "合并糖尿病时优先关注肾脏保护。", "根据夜间血压控制情况评估长效制剂或夜间给药策略。"],
      lifestyleAdvice: [
        "限盐：每日食盐 <5克；推荐钾盐替代（肾功能不全/高钾者慎用）",
        "合理膳食：DASH 饮食模式/ 蔬果、低脂奶制品、少肥肉",
        "体重管理：BMI<24，腰围 男<90、女<85；减重 5%~10%",
        "运动：中等强度有氧运动 ≥150 min/周",
        // "戒烟限酒：彻底戒烟；酒 男≤25克/天、女≤15 g克/天",
        "心理与睡眠：减轻精神压力、保证睡眠，避免熬夜",
      ],
      metrics: [
        {
          title: "整体血压平均值",
          type: "pressure",
          systolic: 127,
          diastolic: 84,
          color: "red-value",
          tone: "blue",
          spark: true,
        },
        {
          title: "白天时段平均值",
          sub: "06:00-22:00",
          type: "pressure",
          systolic: 152,
          diastolic: 95,
          color: "red-value",
          icon: "el-icon-sunny",
          tone: "orange",
          spark: true,
        },
        {
          title: "夜间时段平均值",
          sub: "22:00-06:00",
          type: "pressure",
          systolic: 136,
          diastolic: 84,
          color: "blue-value",
          icon: "el-icon-moon-night",
          tone: "green",
          spark: true,
        },
        {
          title: "白天血压负荷值",
          sub: ">140/90 mmHg 占比",
          type: "load",
          tone: "orange",
          rate: 72,
        },
        {
          title: "夜间血压负荷值",
          sub: ">120/80 mmHg 占比",
          type: "load",
          tone: "green",
          rate: 58,
        },
        {
          title: "脉压差",
          type: "number",
          value: 56,
          unit: "mmHg",
          color: "blue-value",
          tone: "blue",
          spark: true,
        },
        {
          title: "平均动脉压",
          type: "number",
          value: 111,
          unit: "mmHg",
          color: "purple-value",
          tone: "purple",
          spark: true,
        },
      ],
      monitorDate: "2024-05-13 00:00 ~ 2024-05-14 24:00",
      bloodData: {
        evaluateResult: {
          bloodPressureLoadDaytime: "--",
          bloodPressureLoadNight: "--",
        },
        bloodDetail: {
          dayData: {},
          periodData: {},
          staticData: {},
          nightData: {},
          dataCount: {},
          AbnormalDistribution: {
            normal: 0,
            sysRise: 0,
            diaRise: 0,
            sysAndDiaRise: 0,
          },
        },
      },
      bpLevelText: "--",
      daysIndex: 3,
      chart: {
        sysList: [],
        diaList: [],
        hrList: [],
        xIndex: [],
      },
    };
  },
  computed: {
    // metrics() {
    //   return [
    //     { title: '整体血压平均值', type: 'pressure', systolic: this.bpReport.ssy || 127, diastolic: this.bpReport.szy || 84, color: 'red-value', tone: 'blue', spark: true },
    //     { title: '白天时段平均值', sub: '06:00-22:00', type: 'pressure', systolic: 152, diastolic: 95, color: 'red-value', icon: 'el-icon-sunny', tone: 'orange', spark: true },
    //     { title: '夜间时段平均值', sub: '22:00-06:00', type: 'pressure', systolic: 136, diastolic: 84, color: 'blue-value', icon: 'el-icon-moon-night', tone: 'green', spark: true },
    //     { title: '白天血压负荷值', sub: '>135/85 mmHg 占比', type: 'load', tone: 'orange', rate: 72 },
    //     { title: '夜间血压负荷值', sub: '>120/70 mmHg 占比', type: 'load', tone: 'green', rate: 58 },
    //     { title: '脉压差', type: 'number', value: 56, unit: 'mmHg', color: 'blue-value', tone: 'blue', spark: true },
    //     { title: '平均动脉压', type: 'number', value: 111, unit: 'mmHg', color: 'purple-value', tone: 'purple', spark: true }
    //   ]
    // }
  },
  mounted() {
    this.onload();
    // this.$nextTick(() => {
    //   this.initCharts();
    //   window.addEventListener("resize", this.resizeCharts);
    // });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeCharts);
    if (this.trendChart) this.trendChart.dispose();
    if (this.pieChart) this.pieChart.dispose();
  },
  methods: {
    onload() {
      getArchiveInfo(this.wxUserid).then((res) => {
        this.info = res.data || {};
      });

      let days = 1;
      if (this.daysIndex === 1) days = 1;
      else if (this.daysIndex === 2) days = 7;
      else if (this.daysIndex === 3) days = 30;
      this.getBloodDataSplice(days);
      // bpReport(this.wxUserid).then(res => {
      //   if (res.success) this.bpReport = res.data || {}
      // })
      // micProfessional(this.wxUserid).then(res => {
      //   if (res.success) this.proFessional = res.data || {}
      // })
    },

    getBloodDataSplice(day) {
      getBloodDataSplice({
        wxUserId: this.wxUserid,
        days: day,
      }).then((res) => {
        if (res.success) {
          this.bloodData = res.data;
          const data = res.data;
          this.metrics[0].systolic = data.bloodDetail.staticData.sysAvg;
          this.metrics[0].diastolic = data.bloodDetail.staticData.diaAvg;
          this.metrics[1].systolic = data.bloodDetail.dayData.sysAvgDay;
          this.metrics[1].diastolic = data.bloodDetail.dayData.diaAvgDay;
          this.metrics[2].systolic = data.bloodDetail.nightData.sysAvgNight;
          this.metrics[2].diastolic = data.bloodDetail.nightData.diaAvgNight;
          this.metrics[3].rate = data.evaluateResult.bloodPressureLoadDaytime;
          this.metrics[4].rate = data.evaluateResult.bloodPressureLoadNight;
          this.metrics[5].value = data.bloodDetail.staticData.pressureDiffAvg;
          this.metrics[6].value = data.bloodDetail.staticData.arterialPressureAvg;

          this.chart.sysList = res.data.bpChart.map((item) => item.sysAvg);
          this.chart.diaList = res.data.bpChart.map((item) => item.diaAvg);
          this.chart.xIndex = res.data.bpChart.map((item) => item.xindex);
          this.chart.hrList = res.data.hrChart.map((item) => item.hrAvg);

          this.bpReport.bpLevelText = res.data.evaluateResult.bloodLevel || "--";
          this.bpReport.rhythmType = res.data.evaluateResult.dipperBloodRhythm || "--";
          this.bpReport.trendReading = res.data.bloodDetail.trendReading || "--";
          this.bpReport.nightRecentRate = res.data.bloodDetail.nightRecentRate || "--";

          this.monitorDate = data.monitorDate || "--";

          this.initCharts();
          window.addEventListener("resize", this.resizeCharts);
        }
      });
    },

    chickDaysIndex(index) {
      this.daysIndex = index;
      let days = 1;
      if (index === 1) days = 1;
      else if (index === 2) days = 7;
      else if (index === 3) days = 30;
      this.getBloodDataSplice(days);
    },

    initCharts() {
      if (!this.$echarts) return;
      this.initTrendChart();
      this.initPieChart();
    },
    initTrendChart() {
      const el = this.$refs.bpTrendChart;
      if (!el) return;
      this.trendChart = this.$echarts.init(el);
      // const times = [
      //   "00:00",
      //   "01:00",
      //   "02:00",
      //   "03:00",
      //   "04:00",
      //   "05:00",
      //   "06:00",
      //   "07:00",
      //   "08:00",
      //   "09:00",
      //   "10:00",
      //   "11:00",
      //   "12:00",
      //   "13:00",
      //   "14:00",
      //   "15:00",
      //   "16:00",
      //   "17:00",
      //   "18:00",
      //   "19:00",
      //   "20:00",
      //   "21:00",
      //   "22:00",
      //   "23:00",
      //   "24:00"
      // ];
      // const systolic = [
      //   100,
      //   88,
      //   94,
      //   82,
      //   86,
      //   101,
      //   96,
      //   132,
      //   146,
      //   158,
      //   144,
      //   139,
      //   151,
      //   132,
      //   123,
      //   136,
      //   146,
      //   158,
      //   141,
      //   132,
      //   126,
      //   110,
      //   104,
      //   98,
      //   110
      // ];
      // const diastolic = [
      //   72,
      //   64,
      //   66,
      //   58,
      //   60,
      //   68,
      //   72,
      //   82,
      //   91,
      //   98,
      //   95,
      //   91,
      //   100,
      //   87,
      //   82,
      //   90,
      //   96,
      //   98,
      //   89,
      //   84,
      //   76,
      //   70,
      //   68,
      //   73,
      //   80
      // ];
      // const heart = [
      //   38,
      //   33,
      //   30,
      //   28,
      //   31,
      //   42,
      //   37,
      //   41,
      //   43,
      //   44,
      //   46,
      //   42,
      //   45,
      //   40,
      //   43,
      //   44,
      //   42,
      //   39,
      //   42,
      //   43,
      //   36,
      //   34,
      //   31,
      //   38,
      //   40
      // ];

      const times = this.chart.xIndex;
      let systolic = this.chart.sysList;
      let diastolic = this.chart.diaList;
      let heart = this.chart.hrList;
      systolic = systolic.map((v) => (v === 0 || v == null ? null : v));
      diastolic = diastolic.map((v) => (v === 0 || v == null ? null : v));
      heart = heart.map((v) => (v === 0 || v == null ? null : v));

      this.trendChart.setOption({
        color: ["#ef3f4a", "#1d6de3", "#55a873"],
        tooltip: { trigger: "axis" },
        legend: {
          top: 0,
          right: 80,
          itemWidth: 28,
          textStyle: { color: "#394150", fontSize: 12 },
          data: ["收缩压 (mmHg)", "舒张压 (mmHg)", "心率 (次/分)"],
        },
        grid: { left: 38, right: 28, top: 48, bottom: 34 },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: times,
          axisTick: { show: false },
          axisLine: { lineStyle: { color: "#d9e0eb" } },
          axisLabel: { color: "#687080", fontSize: 11 },
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 200,
            interval: 40,
            axisTick: { show: false },
            axisLine: { show: false },
            splitLine: { lineStyle: { color: "#edf1f7" } },
            axisLabel: { color: "#687080", fontSize: 11 },
          },
          {
            type: "value",
            min: 0,
            max: 150,
            interval: 30,
            axisTick: { show: false },
            axisLine: { show: false },
            splitLine: { show: false },
            axisLabel: { color: "#55a873", fontSize: 11 },
          },
        ],
        series: [
          {
            name: "收缩压 (mmHg)",
            type: "line",
            smooth: true,
            symbolSize: 4,
            data: systolic,
          },
          {
            name: "舒张压 (mmHg)",
            type: "line",
            smooth: true,
            symbolSize: 4,
            data: diastolic,
          },
          {
            name: "心率 (次/分)",
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            symbolSize: 3,
            data: heart,
          },
        ],
      });
    },

    initPieChart() {
      const data = [
        { value: this.bloodData.bloodDetail.AbnormalDistribution.sysRise, name: "收缩压升高" },
        { value: this.bloodData.bloodDetail.AbnormalDistribution.diaRise, name: "舒张压升高" },
        { value: this.bloodData.bloodDetail.AbnormalDistribution.sysAndDiaRise, name: "收缩压&舒张压均升高" },
        { value: this.bloodData.bloodDetail.AbnormalDistribution.normal, name: "正常范围" },
      ];

      const el = this.$refs.bpPieChart;
      if (!el) return;
      this.pieChart = this.$echarts.init(el);
      this.pieChart.setOption({
        color: ["#5b9ee8", "#8a82df", "#f3a15c", "#76b879"],
        tooltip: { trigger: "item", formatter: "{b}: {d}%" },
        legend: {
          orient: "vertical",
          right: 10,
          top: 8,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { fontSize: 12, color: "#394150" },
        },
        series: [
          {
            type: "pie",
            radius: ["0%", "64%"],
            center: ["28%", "54%"],
            label: {
              formatter: "{d}%",
              color: "#fff",
              fontSize: 13,
              fontWeight: 700,
            },
            labelLine: { show: false },
            data: data,
            // data: [
            //   { value: 10, name: "收缩压升高" },
            //   { value: 20, name: "舒张压升高" },
            //   { value: 30, name: "收缩压&舒张压均升高" },
            //   { value: 40, name: "正常范围" },
            // ],
          },
        ],
      });
    },
    resizeCharts() {
      if (this.trendChart) this.trendChart.resize();
      if (this.pieChart) this.pieChart.resize();
    },
    click(index) {
      const paths = ["/agent/blood/archive", "/agent/blood/nutritionalPlan", "/agent/blood/bodyComposition", "/agent/blood/exercisePlan", "/agent/blood/behavioralTherapy", "/agent/blood/sportsFollow", "/agent/blood/drugRegimen"];
      this.$router.push({
        path: paths[index],
        query: { wxUserId: this.wxUserid },
      });
    },
  },
};
</script>

<style scoped>
.bp-report-page {
  min-height: 100vh;
  padding: 8px 14px 12px;
  background: #f4f7fb;
  color: #202938;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.page-tabs {
  margin-bottom: 6px;
}

.healthButton {
  color: #1f2937;
  border: 0;
  border-radius: 0;
  font-size: 14px;
  background: transparent;
}

.healthActive {
  border-bottom: 3px solid #1684f7;
  color: #1684f7;
  font-weight: 700;
}

.panel-blood {
  background: #fff;
  border: 1px solid #e3e9f2;
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(34, 65, 112, 0.08);
}

.patient-bar {
  height: 48px;
  display: grid;
  grid-template-columns: 44px 1.1fr 0.7fr 0.8fr 1.35fr 2.25fr 1fr;
  align-items: center;
  padding: 0 16px 0 8px;
  margin-bottom: 6px;
  font-size: 14px;
  white-space: nowrap;
}

.patient-avatar {
  width: 31px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-size: 23px;
  background: linear-gradient(180deg, #20a2ff 0%, #0463e8 100%);
}

.section-title {
  height: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  color: #1e2a3b;
  font-size: 15px;
  font-weight: 700;
  border-bottom: 1px solid #edf1f7;
}

.section-title span {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  border-radius: 50%;
  background: #1684f7;
}

.section-title small {
  color: #8c95a4;
  font-size: 12px;
  font-weight: 400;
}

.result-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.45fr;
  gap: 12px;
  padding: 10px 14px;
}

.result-card {
  min-height: 74px;
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0 28px;
  border: 1px solid #e5ebf2;
  border-radius: 8px;
  background: #fff;
}

.result-icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #fff;
  font-size: 28px;
}

.result-icon.red {
  background: linear-gradient(135deg, #f17c82, #ea515a);
}

.result-icon.orange {
  background: linear-gradient(135deg, #f7ab63, #ef8034);
}

.result-icon.teal {
  background: linear-gradient(135deg, #42cfc5, #16a9a8);
}

.result-icon.purple {
  background: linear-gradient(135deg, #a98bf4, #7765e8);
}

.result-label {
  margin-bottom: 6px;
  color: #364052;
  font-size: 14px;
}

.result-value {
  font-size: 24px;
  line-height: 1.15;
  font-weight: 800;
}

.danger {
  color: #f03f47;
}

.teal-text {
  color: #16a9a8;
}

.detail-panel {
  position: relative;
  margin-top: 6px;
}

.analysis-tabs {
  position: absolute;
  top: 8px;
  left: 456px;
  display: flex;
  gap: 4px;
}

.analysis-tabs button {
  min-width: 75px;
  height: 24px;
  border: 1px solid #d9e2ef;
  border-radius: 4px;
  color: #637084;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
}

.analysis-tabs .active {
  color: #fff;
  border-color: #1684f7;
  background: #1684f7;
  font-weight: 700;
}

.detail-layout {
  display: grid;
  grid-template-columns: 424px minmax(560px, 1fr) 132px;
  align-items: stretch;
  gap: 10px;
  padding: 8px 12px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-template-rows: 126px 140px;
  gap: 6px;
}

.metric-card {
  min-height: 0;
  padding: 8px 9px 7px;
  border: 1px solid #e5ebf2;
  border-radius: 7px;
  background: #fff;
  overflow: hidden;
}

.metric-card:nth-child(1),
.metric-card:nth-child(2),
.metric-card:nth-child(3) {
  grid-column: span 4;
}

.metric-card:nth-child(n + 4) {
  grid-column: span 3;
}

.metric-head {
  min-height: 31px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #526071;
}

.metric-head i {
  color: #1684f7;
  font-size: 17px;
}

.metric-head.centered {
  justify-content: center;
  text-align: center;
}

.metric-title {
  color: #334155;
  font-size: 11px;
  font-weight: 700;
}

.metric-sub {
  margin-top: 1px;
  color: #8490a1;
  font-size: 9px;
}

.pressure-values {
  margin-top: 8px;
}

.pressure-values div {
  display: grid;
  grid-template-columns: 42px 1fr 30px;
  align-items: baseline;
  margin-bottom: 7px;
  color: #2f3a4a;
  font-size: 11px;
}

.pressure-values strong {
  justify-self: center;
  font-size: 22px;
  line-height: 1;
  font-weight: 800;
}

.pressure-values em,
.single-value em {
  color: #4b5563;
  font-size: 9px;
  font-style: normal;
  font-weight: 600;
}

.single-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 7px;
  margin-top: 22px;
}

.single-value strong {
  font-size: 23px;
  line-height: 1;
  font-weight: 800;
}

.red-value {
  color: #ef3f4a;
}

.blue-value {
  color: #1d6de3;
}

.purple-value {
  color: #7b5eea;
}

.sparkline {
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-top: 8px;
  overflow: hidden;
}

.sparkline span {
  width: 12px;
  height: 2px;
  margin-left: -1px;
  border-radius: 2px;
  background: #78a8e8;
  transform: rotate(var(--deg, -18deg)) translateY(calc(var(--h) / 8));
}

.sparkline span:nth-child(2n) {
  --deg: 20deg;
}

.sparkline span:nth-child(3n) {
  --deg: -26deg;
}

.sparkline.orange span {
  background: #f4a661;
}

.sparkline.green span {
  background: #69b783;
}

.sparkline.purple span {
  background: #8f7ae6;
}

.ring {
  --rate: 50%;
  width: 68px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 7px auto 0;
  border-radius: 50%;
  background: conic-gradient(#f59b4b var(--rate), #eef2f7 0);
}

.ring.green {
  background: conic-gradient(#5eb77b var(--rate), #eef2f7 0);
}

.ring span {
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #f08b35;
  background: #fff;
  font-weight: 800;
  font-size: 12px;
}

.ring.green span {
  color: #4daa6a;
}

.load-note {
  height: 21px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  color: #8a94a3;
  font-size: 10px;
  border: 1px solid #e5ebf2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  background: #fff;
}

.trend-card {
  position: relative;
  min-height: 260px;
  padding: 8px 10px 0;
  border-left: 1px solid #eef2f7;
}

.chart-title {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 1;
  color: #223047;
  font-size: 14px;
  font-weight: 700;
}

.chart-title::before,
.sub-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 6px;
  vertical-align: -2px;
  background: #1684f7;
}

.trend-chart {
  width: 100%;
  height: 264px;
}

.trend-reading {
  min-height: 260px;
  padding: 12px 8px 4px 12px;
  border-left: 1px solid #e5ebf2;
  color: #303a49;
  font-size: 13px;
}

.side-title {
  margin-bottom: 10px;
  color: #334155;
  font-weight: 700;
}

.side-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 18px;
  margin-right: 8px;
  vertical-align: -4px;
  background: #20bfc4;
}

.trend-reading p {
  margin: 0 0 20px;
  line-height: 1.7;
  font-weight: 700;
}

.reading-block {
  margin-top: 16px;
}

.reading-block span {
  display: block;
  color: #64748b;
  margin-bottom: 6px;
}

.reading-block strong {
  color: #52b98a;
  font-size: 20px;
}

.compare-panel {
  display: grid;
  grid-template-columns: 41% 39% 20%;
  margin-top: 6px;
  min-height: 112px;
}

.compare-card {
  padding: 10px 12px;
  border-right: 1px solid #edf1f7;
}

.sub-title {
  color: #223047;
  font-size: 14px;
  font-weight: 700;
}

.load-rings {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 8px;
}

.load-item {
  color: #4b5563;
  text-align: center;
  font-size: 12px;
}

.legend {
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: #5f6b7a;
  font-size: 12px;
}

.legend i {
  display: inline-block;
  width: 18px;
  height: 8px;
  margin-right: 8px;
  background: #e5e7eb;
}

.legend i.passed {
  background: #5eb77b;
}

.pie-chart {
  height: 88px;
}

.data-overview {
  margin: 8px 12px;
  padding: 10px 14px;
  border: 1px solid #dbe6f2;
  border-radius: 6px;
  background: #f8fbff;
}

.data-overview ul {
  margin: 8px 0 0;
  padding-left: 18px;
  color: #334155;
  line-height: 1.65;
  font-size: 13px;
}

.bottom-grid {
  display: grid;
  grid-template-columns: 41% 59%;
  gap: 6px;
  margin-top: 6px;
}

.symptom-grid {
  display: grid;
  grid-template-columns: 1.45fr 1fr 1fr;
  gap: 8px;
  padding: 8px;
}

.symptom-card {
  min-height: 100px;
  padding: 9px 10px;
  border: 1px solid #e5ebf2;
  border-radius: 6px;
  background: #fff;
}

.symptom-title,
.guide-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: #f2762e;
  font-size: 15px;
  font-weight: 800;
}

.green-title,
.guide-title.green {
  color: #18a883;
}

.purple-title,
.guide-title.purple {
  color: #6f65e8;
}

.guide-title.blue {
  color: #1684f7;
}

.two-col-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px 10px;
  color: #2f3948;
  font-size: 13px;
}

.two-col-list i,
.check-list i {
  margin-right: 7px;
  color: #21ad82;
}

.check-list {
  margin: 0;
  padding: 0;
  list-style: none;
  color: #2f3948;
  font-size: 13px;
  line-height: 1.75;
}

.guidance-grid {
  display: grid;
  grid-template-columns: 1.15fr 1.15fr 0.7fr;
  gap: 8px;
  padding: 8px;
}

.guidance-grid > div {
  padding: 8px 10px;
  border-left: 1px solid #edf1f7;
}

.guidance-grid > div:first-child {
  border-left: 0;
}

.follow-card {
  color: #334155;
  font-size: 13px;
}

.follow-card p {
  margin: 5px 0;
}

.key-focus {
  margin-top: 9px;
  padding-top: 8px;
  border-top: 1px solid #eef2f7;
}

.key-focus div {
  color: #f49b2f;
  font-size: 15px;
  font-weight: 800;
}

.key-focus span {
  display: inline-block;
  margin: 6px 4px 0 0;
  padding: 2px 8px;
  color: #e64a54;
  border: 1px solid #f3bac1;
  border-radius: 4px;
  background: #fff7f8;
}

.key-focus span:last-child {
  color: #5f64d8;
  border-color: #bfc4f5;
  background: #f8f8ff;
}

.summary-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  margin-top: 6px;
  padding: 0 14px;
  color: #1684f7;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid #dce8f6;
  border-radius: 6px;
  background: #fff;
}

@media (max-width: 1360px) {
  .detail-layout {
    grid-template-columns: 424px minmax(460px, 1fr) 124px;
  }

  .result-card {
    padding: 0 16px;
  }

  .result-value {
    font-size: 20px;
  }
}
</style>
